import axios from 'axios';
import { tokenService, checkVersionMismatch } from 'utils/services';
import { AUTH_TOKEN } from '_constants';
import { baseUrl } from 'lib/baseUrl';
import { createOfflineAdapter, shouldUseOfflineAdapter } from 'lib/offlineHttpAdapter';

const _API = axios.create({
  // withCredentials: true
  timeout: 30000,
  headers: {
    accept: 'application/vnd.api+json, application/json',
    'X-Version': '2.0',
  },
});

_API.interceptors.response.use((response) => {
  checkVersionMismatch(response);
  if (response.data.token && (response.config.url.includes('auth') || response.config.url.includes('bootstrap'))) {
    tokenService.manageToken(response.data.token);
  }
  return Promise.resolve(response.data);
});

// Snapshot the default network adapter so the offline adapter can fall
// through to it for endpoints we don't serve from IDB.
const networkAdapter = _API.defaults.adapter;

/**
 * Add API_URL to request url before sending request. When offline mode is on
 * (or the network is genuinely down) swap in the offline adapter so the
 * request is served from IDB instead of hitting DNS — this keeps the offline
 * experience working even when the service worker isn't controlling the page.
 */
_API.interceptors.request.use((config) => {
  const authToken = tokenService.getToken();
  // eslint-disable-next-line no-param-reassign
  if (authToken) config.headers[AUTH_TOKEN] = `Token ${authToken}`;
  // eslint-disable-next-line no-param-reassign
  config.url = `${baseUrl}${config.url}`;
  if (shouldUseOfflineAdapter()) {
    // eslint-disable-next-line no-param-reassign
    config.adapter = createOfflineAdapter(networkAdapter);
  }
  // config.withCredentials = true;
  return config;
});

export default _API;
